import { Outlet } from "@tanstack/react-router";
import { Flex } from "src/components";
import { Header } from "./header";
import styling from "./RootPage.module.scss";

export const RootPage = () => {
	return (
		<Flex.Column
			alignment="top-left"
			width="stretch"
			className={styling.content}
		>
			<Header />
			<Flex.Column
				render={<main />}
				alignment="top-left"
				width="100%"
				className={styling.main}
			>
				<Outlet />
			</Flex.Column>
		</Flex.Column>
	);
};
